import clsx from 'clsx';
import { lazy } from 'react';

import { EditButton } from 'src/components/Button';
import { createResizableWindow } from 'src/components/ResizableWindow';
import { Factory } from 'src/components/Factory';

import classes from './Password.module.scss';

const ChangePasswordSendCodeModal = lazy(() => import('src/domains/passwordUpdate/ChangePasswordSendCodeModal'));

const ChangePasswordCheckCodeModal = lazy(() => import('src/domains/passwordUpdate/ChangePasswordCheckCodeModal'));

const CreateNewPasswordModal = lazy(() => import('src/domains/passwordUpdate/CreateNewPasswordModal'));

export function Password() {
  function showCreateNewPasswordModal(token: string) {
    createResizableWindow(
      <Factory>
        <CreateNewPasswordModal token={token} />
      </Factory>,
      { y: window.innerHeight * 0.3 },
    );
  }

  function showCodeValidationModal() {
    createResizableWindow(
      <Factory>
        <ChangePasswordCheckCodeModal onSubmit={showCreateNewPasswordModal} />
      </Factory>,
      { y: window.innerHeight * 0.3 },
    );
  }

  function handleOnEdit() {
    createResizableWindow(
      <Factory>
        <ChangePasswordSendCodeModal onSubmit={showCodeValidationModal} />
      </Factory>,
      { y: window.innerHeight * 0.3 },
    );
  }

  return (
    <div className={clsx(classes.container, 'row items-p8 a-center w-100p o-hidden')}>
      <p className='f-1 c-default'>●●●●●●●●</p>
      <EditButton onClick={handleOnEdit} />
    </div>
  );
}
